

const PLATFORM_FEE_RATE = 0.02;
const GST_RATE = 0.18;

const calculateFinalPrice = (discountedPrice) => {
  const fee = discountedPrice * PLATFORM_FEE_RATE;
  const gstOnFee = fee * GST_RATE;
  return Number((discountedPrice + fee + gstOnFee).toFixed(1));
};

const BASE_PRODUCTS = [
  {
  id: "FD1928374650ABCD",
  name: "Food Delivery",
  shortDescription:
    "Connects customers with restaurants through digital ordering, secure payments, and efficient delivery management.",
  description:
    "Food Delivery platforms connect customers with restaurants through digital ordering systems. They enable users to browse menus, place orders, and make secure online payments. These services optimize logistics by assigning delivery partners efficiently. Businesses gain wider customer reach and improved sales visibility. Customers benefit from convenience, speed, and real-time order tracking.",
  price: 230000,
  originalPrice: 250000,
  image: "image/food-delivery.png",
  createdAt: "2024-01-05T10:15:00Z",
}
,
  {
    id: "ST5647382910XYZW",
    name: "School Tech",
    sector: "Education Technology",
    shortDescription:"Digitizes academic and administrative operations in schools, enabling online learning, performance tracking, and efficient school management.",
    description:
      "School Tech solutions digitize academic and administrative processes in educational institutions. They support online learning, attendance tracking, and student performance monitoring. Teachers can manage lesson plans and assessments efficiently. Parents receive real-time updates on student progress and activities. Schools improve operational efficiency and learning outcomes through automation.",
    price: 210000,
    originalPrice: 250000,
    image: "image/School-Tech.png",
    createdAt: "2024-01-06T11:30:00Z",
  },
   {
    id: "CS000111222HJKKL",
    name: "Cyber Security",
    sector: "Cybersecurity",
    shortDescription:"Protects digital systems, networks, and sensitive data from cyber threats through monitoring, detection, and advanced security solutions.",
    description:
      "Cyber Security solutions protect digital assets from cyber threats. They safeguard networks, systems, and sensitive data. Continuous monitoring detects potential vulnerabilities. Businesses reduce risks of data breaches and downtime. Strong security builds customer trust and compliance.",
    price: 500000,
    originalPrice: 550000,
    image: "image/cyber-security.png",
    createdAt: "2024-01-07T12:00:00Z",
  },
  {
    id: "3D1122334455AAXB",
    name: "3D Application Tech",
    sector: "Software & Visualization",
    shortDescription:"Enables visualization and manipulation of 3D models for design, simulation, engineering, and interactive digital experiences.",
    description:
      "3D Application Technology enables visualization and manipulation of three-dimensional models. It is widely used in design, engineering, architecture, and gaming industries. Users can inspect models from multiple angles with precision. Advanced rendering improves realism and simulation accuracy. This technology enhances productivity and decision-making processes.",
    price: 290000,
    originalPrice: 300000,
    image: "image/3D.png",
    createdAt: "2024-01-08T13:00:00Z",
  },
  {
    id: "TR6677889900LMNOP",
    name: "Transportation Tech",
    sector: "Transportation & Logistics",
    shortDescription:"Improves movement of goods and people using route optimization, real-time tracking, and intelligent logistics management systems.",
    description:
      "Transportation Tech improves movement of goods and people using digital systems. It optimizes routes, reduces fuel consumption, and improves delivery timelines. Real-time tracking enhances transparency and operational control. Businesses can manage fleets efficiently using analytics. Customers benefit from faster and more reliable transportation services.",
    price: 250000,
    originalPrice: 275000,
    image: "image/Transportation-Technology.png",
    createdAt: "2024-01-09T14:00:00Z",
  },
  {
    id: "EP12340987MNBVCX",
    name: "Evaluation of Property",
    sector: "Real Estate Services",
    shortDescription:"Provides accurate property valuation using location data and market trends to support informed real estate decisions.",
    description:
      "Property Evaluation technology helps determine accurate property values. It considers factors like location, amenities, and market trends. Automated valuation reduces human error and bias. Real estate professionals gain data-backed insights for decision-making. Buyers and sellers benefit from fair and transparent pricing.",
    price: 240000,
    originalPrice: 250000,
    image: "image/Evaluation-of-Property.png",
    createdAt: "2024-01-10T15:00:00Z",
  },
  {
    id: "VS43215678LKJHGF",
    name: "Vehicle & Software Tech",
    sector: "Automotive Technology",
    shortDescription:"Integrates smart software into vehicles for diagnostics, performance monitoring, predictive maintenance, and enhanced driving safety.",
    description:
      "Vehicle and Software Technology integrates digital intelligence into automobiles. It enables diagnostics, performance monitoring, and predictive maintenance. Advanced software improves safety and driving experience. Fleet operators can track vehicles remotely in real time. This technology supports the future of connected and smart vehicles.",
    price: 190000,
    originalPrice: 200000,
    image: "image/Vehicle-EvaluationandSoftware-related-tech.png",
    createdAt: "2024-01-11T16:00:00Z",
  },
  {
    id: "QR98765432POIUYT",
    name: "QR House Access",
    sector: "Smart Home Technology",
    shortDescription:"Enables secure property access using QR codes, eliminating physical keys and allowing digital permission management.",
    description:
      "QR House Access systems enable secure entry using QR codes. They eliminate the need for physical keys or access cards. Property owners can grant or revoke access digitally. The system enhances security through controlled authentication. It is ideal for smart homes and rental properties.",
    price: 230000,
    originalPrice: 250000,
    image: "image/QR-Code.png",
    createdAt: "2024-01-12T17:00:00Z",
  },
  {
    id: "TB444555666RTYUI",
    name: "Ticket Booking Tech",
    sector: "Travel & Events",
    shortDescription:"Facilitates online reservation of travel and event tickets with real-time availability, secure payments, and dynamic inventory management.",
    description:
      "Ticket Booking Technology simplifies reservation of travel and event tickets. Users can browse availability and make instant bookings online. Secure payment gateways ensure safe transactions. Businesses can manage inventory and pricing dynamically. Customers enjoy convenience and time savings.",
    price: 290000,
    originalPrice: 300000,
    image: "image/Ticket-booking.png",
    createdAt: "2024-01-13T18:00:00Z",
  },
  {
    id: "TE111222333QQWEE",
    name: "Tech Enabler",
    sector: "Enterprise Software",
    shortDescription:"Provides scalable digital infrastructure for enterprises, supporting automation, analytics, and cloud-based operations to enhance efficiency.",
    description:
      "Tech Enabler platforms provide scalable digital infrastructure for enterprises. They support automation, analytics, and cloud-based operations. Businesses can integrate multiple services seamlessly. These platforms improve efficiency and reduce operational costs. They are essential for digital transformation initiatives.",
    price: 370000,
    originalPrice: 400000,
    image: "image/TechEnabler-platform.png",
    createdAt: "2024-01-14T19:00:00Z",
  },
  {
    id: "BA45678901ZXCVBN",
    name: "Business Access Tech",
    sector: "Security Technology",
    shortDescription:"Secures commercial properties using smart authentication methods, centralized permission management, and detailed access logs for enhanced security.",
    description:
      "Business Access Technology secures offices and commercial properties digitally. It uses smart authentication like biometrics or mobile access. Entry logs improve security auditing and monitoring. Organizations can manage permissions centrally. This reduces security risks and operational overhead.",
    price: 350000,
    originalPrice: 400000,
    image: "image/Business-and-apartment-acccess.png",
    createdAt: "2024-01-15T20:00:00Z",
  },
  {
    id: "BC777888999ASDFG",
    name: "Business Consultancy",
    sector: "Consulting Services",
    shortDescription:"Offers data-driven insights and automated tools to help businesses optimize strategy, performance, and growth through customized solutions.",
    description:
      "Business Consultancy services help organizations improve strategy and performance. They provide insights based on data analysis and industry expertise. Automation tools enhance consulting efficiency. Clients receive customized solutions for growth challenges. This enables sustainable and scalable business success.",
    price: 170000,
    originalPrice: 200000,
    image: "image/Business-consultancyy.png",
    createdAt: "2024-01-16T21:00:00Z",
  },
  {
    id: "NG9988776655QMZN",
    name: "NGO",
    sector: "Social Impact",
    shortDescription:"Supports non-governmental organizations with digital tools for managing donations, volunteers, outreach, and impact analysis to enhance transparency and efficiency.",
    description:
      "NGO platforms support organizations working towards social welfare and community development. They help manage donations, volunteers, and outreach programs digitally. Transparency in operations builds donor trust and accountability. NGOs can analyze impact through structured data collection. Technology enables scalable and sustainable social initiatives.",
    price: 150000,
    originalPrice: 175000,
    image: "image/NGO.png",
    createdAt: "2024-01-17T22:00:00Z",
  },
  {
    id: "RE333444555VBNMM",
    name: "Real Estate",
    sector: "Real Estate",
    shortDescription:"Streamlines property transactions with digital listings, pricing insights, and document management for buyers, sellers, and investors.",
    description:
      "Real Estate platforms streamline buying, selling, and managing properties. They provide listings, pricing insights, and documentation support. Digital tools improve transparency in transactions. Investors can analyze market trends efficiently. This simplifies property management and decision-making.",
    price: 230000,
    originalPrice: 250000,
    image: "image/real-estate.png",
    createdAt: "2024-01-18T23:00:00Z",
  },
  {
    id: "AI999000111QWERT",
    name: "AIML",
    sector: "Artificial Intelligence",
    shortDescription:"Leverages AI and ML to automate tasks, analyze data, and enhance user experiences through intelligent solutions like chatbots and recommendation engines.",
    description:
      "AI and ML solutions enable intelligent automation and data-driven decisions. They analyze large datasets to identify patterns and insights. Chatbots and recommendation engines enhance user experience. Businesses improve efficiency through predictive analytics. AI drives innovation across industries.",
    price: 600000,
    originalPrice: 630000,
    image: "image/AIML.png",
    createdAt: "2024-01-19T10:15:00Z",
  },
  {
    id: "RA888777666UIOPL",
    name: "Robotics & Automation",
    sector: "Industrial Automation",
    shortDescription:"Implements robotic systems to automate repetitive tasks, improve precision, and enhance productivity in industrial operations.",
    description:
      "Robotics and Automation systems improve efficiency in industrial operations. They perform repetitive tasks with high precision. Automation reduces human error and operational costs. Industries benefit from increased productivity and safety. This technology supports smart manufacturing.",
    price: 350000,
    originalPrice: 380000,
    image: "image/robotics-automation.png",
    createdAt: "2024-01-20T10:30:00Z",
  },
  {
    id: "SW222333444GHJKL",
    name: "Smart Watch",
    sector: "Wearable Technology",
    shortDescription:"Combines health tracking and smart connectivity features, providing fitness metrics, notifications, and mobile app integration for a healthier lifestyle.",
    description:
      "Smart Watches combine health tracking with smart connectivity features. They monitor fitness metrics like heart rate and steps. Notifications keep users connected on the go. Integration with mobile apps enhances usability. Wearables promote healthier and smarter lifestyles.",
    price: 1000000,
    originalPrice: 1075000,
    image: "image/smartwatch.png",
    createdAt: "2024-01-21T10:40:00Z",
  },
  {
    id: "DT555666777MNBVC",
    name: "Drone Tech",
    sector: "Aerospace Technology",
    shortDescription:"Utilizes unmanned aerial vehicles for data collection, surveillance, delivery, and mapping with high precision and reduced operational risks.",
    description:
      "Drone Technology enables aerial data collection and automation. It is used in surveillance, delivery, and mapping applications. Drones operate remotely with high precision. They reduce operational costs and human risk. This technology transforms multiple industries.",
    price: 700000,
    originalPrice: 730000,
    image: "image/drone-tech.png",
    createdAt: "2024-01-22T11:00:00Z",
  },
  {
    id: "GS12121212ABABAB",
    name: "General Store",
    sector: "Retail",
    shortDescription:"Provides essential goods to communities with inventory management, billing systems, and customer data for improved service and efficiency.",
    description:
      "General Store businesses provide essential goods to local communities. Digital systems help manage inventory and billing. Customer data improves service personalization. Automation reduces manual errors. Retailers improve efficiency and profitability.",
    price: 700000,
    originalPrice: 750000,
    image: "image/general-store.png",
    createdAt: "2024-01-23T12:00:00Z",
  },
  {
    id: "GR34343434CDCDCD",
    name: "Groceries",
    sector: "Retail & FMCG",
    shortDescription:"Manages grocery inventory, supplier relationships, and online ordering to ensure efficient distribution of daily essentials to customers.",
    description:
      "Grocery platforms manage daily essentials distribution efficiently. They track inventory and manage supplier relationships. Online ordering improves customer convenience. Analytics help optimize pricing and demand forecasting. This ensures consistent supply and quality.",
    price: 190000,
    originalPrice: 200000,
    image: "image/groceries.png",
    createdAt: "2024-01-24T13:00:00Z",
  },
  {
    id: "EC56565656EFEFEF",
    name: "E Commerce Tech",
    sector: "E-Commerce",
    shortDescription:"Facilitates online buying and selling of products through digital catalogs, secure payments, and order tracking for global reach and improved sales performance.",
    description:
      "E-Commerce Technology enables online buying and selling of products. It supports digital catalogs, payments, and order tracking. Businesses reach global audiences easily. Analytics improve customer targeting and sales performance. This drives scalable online growth.",
    price: 200000,
    originalPrice: 550000,
    image: "image/ecommerce.png",
    createdAt: "2024-01-25T13:10:00Z",
  },
  {
    id: "SM78787878GHGHGH",
    name: "Social Media",
    sector: "Social Networking",
    shortDescription:"Enables content sharing and communication through posts, messages, and multimedia, strengthening digital presence for users and businesses.",
    description:
      "Social Media platforms enable content sharing and communication. Users connect through posts, messages, and multimedia. Businesses leverage platforms for marketing and engagement. Analytics track reach and audience behavior. Social media strengthens digital presence.",
    price: 270000,
    originalPrice: 300000,
    image: "image/social-media.png",
    createdAt: "2024-01-26T13:20:00Z",
  },
  {
    id: "GF90909090IJIJIJ",
    name: "Gym Fitness",
    sector: "Health & Fitness",
    shortDescription:"Supports physical training programs with workout tracking, membership management, and trainer-client interaction to enhance fitness outcomes.", 
    description:
      "Gym Fitness solutions support structured physical training programs. They track workouts, memberships, and progress. Digital systems enhance trainer-client interaction. Analytics help improve fitness outcomes. This promotes healthier lifestyles and engagement.",
    price: 190000,
    originalPrice: 200000,
    image: "image/gym-fitness.png",
    createdAt: "2024-01-27T13:30:00Z",
  },
  {
    id: "SH12312312KLKLKL",
    name: "Sales and HR Tech",
    sector: "Enterprise HR & Sales",
    shortDescription:"Automates employee and sales operations, improving recruitment, payroll, lead management, and performance tracking for scalable business growth.",
    description:
      "Sales and HR Technology automates employee and sales operations. It manages recruitment, payroll, and performance tracking. Sales tools improve lead management and conversions. Analytics provide actionable insights. Businesses scale operations efficiently.",
    price: 500000,
    originalPrice: 525000,
    image: "image/sales-hr.png",
    createdAt: "2024-01-28T13:40:00Z",
  },
  {
    id: "FT45645645MNMNMN",
    name: "Family Tech",
    sector: "Lifestyle Technology",
    shortDescription:"Integrates technology to organize family schedules, communication, safety, and smart home connectivity for enhanced convenience and peace of mind.",
    description:
      "Family Tech solutions help manage household activities digitally. They organize schedules, communication, and reminders. Safety and monitoring features enhance peace of mind. Integration with smart devices improves convenience. Families stay connected and organized.",
    price: 230000,
    originalPrice: 250000,
    image: "image/family-tech.png",
    createdAt: "2024-01-29T13:50:00Z",
  },
  {
    id: "TT78978978OPOPOP",
    name: "Temple Tech",
    sector: "Religious & Community Tech",
    shortDescription:"Digitizes temple operations and services, managing donations, events, and devotee communication for transparency and spiritual engagement.",
    description:
      "Temple Tech platforms digitize temple operations and services. They manage donations, events, and devotee communication. Transparency builds trust among communities. Digital records simplify administration. Technology enhances spiritual engagement.",
    price: 340000,
    originalPrice: 350000,
    image: "image/temple-tech.png",
    createdAt: "2024-01-30T14:00:00Z",
  },
  {
    id: "VT01010101QRQRQR",
    name: "Village Tech",
    sector: "Rural Development",
    shortDescription:"Empowers rural communities with digital solutions to improve access to services, sustainable development, and governance through technology.",
    description:
      "Village Tech empowers rural communities through digital solutions. It improves access to services like education and healthcare. Technology supports sustainable development initiatives. Data-driven insights improve planning and governance. This bridges the urban-rural gap.",
    price: 190000,
    originalPrice: 215000,
    image: "image/village-tech.png",
    createdAt: "2024-01-31T15:00:00Z",
  },
  {
    id: "CE23232323STSTST",
    name: "Competitive Exams App",
    sector: "Education Technology",
    shortDescription:"Helps students prepare for entrance exams with mock tests, study materials, personalized learning, and progress tracking to improve performance.",
    description:
      "Competitive Exams Apps help students prepare for entrance exams. They provide mock tests, study materials, and analytics. Personalized learning improves performance. Progress tracking keeps students motivated. Technology makes exam preparation accessible.",
    price: 190000,
    originalPrice: 225000,
    image: "image/exams-app.png",
    createdAt: "2024-02-01T16:00:00Z",
  },
  {
    id: "JW45454545UVUVUV",
    name: "Jewelry",
    sector: "Luxury & Fashion",
    shortDescription:"Combines design, craftsmanship, and digital platforms to enhance inventory management, customer reach, and secure transactions in the jewelry market.", 
    description:
      "Jewelry businesses focus on design, craftsmanship, and branding. Digital platforms manage inventory and customer relationships. Online catalogs improve reach and sales. Secure transactions build customer trust. Technology modernizes traditional luxury markets.",
    price: 190000,
    originalPrice: 215000,
    image: "image/jewelry.png",
    createdAt: "2024-02-02T17:00:00Z",
  },
  {
    id: "MT67676767WXYWXY",
    name: "Media Tech",
    sector: "Media & Publishing",
    shortDescription:"Enables digital content creation, distribution, and personalization through analytics and automation to adapt to modern media consumption habits.",
    description:
      "Media Technology enables digital content creation and distribution. It supports news publishing, streaming, and personalization. Analytics track audience engagement. Automation improves content delivery speed. Media platforms adapt to modern consumption habits.",
    price: 190000,
    originalPrice: 200000,
    image: "image/media-tech.png",
    createdAt: "2024-02-03T18:00:00Z",
  },
  {
  id: "AT8989XYTRAD12", 
  name: "Algo Trade",
  sector: "FinTech & Trading",
  shortDescription:
    "Automates trading decisions using algorithms and real-time data to optimize financial market returns.",
  description:
    "Uses advanced algorithms and real-time market data to automate trading decisions, reduce risk, and maximize returns across financial markets.",
  price: 1000000,            // 10L
  originalPrice: 1200000,    // 12L
  image: "image/algo-tradee.png",
  createdAt: "2024-02-04T19:00:00Z",
},
{
  id: "IM4545MKTGXY22",
  name: "Influencer Marketing",
  sector: "Marketing & Advertising",
  shortDescription:
    "Connects brands with relevant influencers to boost engagement and conversions on social media.",
  description:
    "Connects brands with relevant influencers using data-driven insights to increase reach, engagement, and conversions across social platforms.",
  price: 300000,             // 3L
  originalPrice: 400000,     // 4L
  image: "image/influencer-marketingg.png",
  createdAt: "2024-02-05T20:00:00Z",
},
{
  id: "CB3030CHAT987XY",
  name: "Chat Bot",
  sector: "AI & Customer Support",
  shortDescription:
    "AI-powered assistant that automates customer support and enhances user engagement.",
  description:
    "AI-powered conversational assistant that automates customer support, handles queries 24/7, and improves user engagement efficiently.",
  price: 100000,             // 1L
  originalPrice: 150000,     // 1.5L
  image: "image/chat-bott.png",
  createdAt: "2024-02-06T21:00:00Z",
},
{
    id: "AP88776655APT44S",
    name: "Apartment Tech",
    sector: "PropTech & Management",
    shortDescription: "Streamlines apartment living with automated maintenance requests, visitor management, and digital community interaction.",
    description:
      "Apartment Tech provides a comprehensive digital platform for residents and property managers. It automates maintenance ticketing, facilitates secure visitor entry, and handles amenity bookings. It also streamlines rent payments and community announcements. This technology improves operational transparency and enhances the living experience for residents.",
    price: 320000,
    originalPrice: 350000,
    image: "image/apartmentt-techh.png",
    createdAt: "2024-02-07T22:00:00Z",
  },
  {
    id: "MR112233MEDREP9Z",
    name: "Medical Report Tech",
    sector: "HealthTech & Diagnostics",
    shortDescription: "Digitizes medical reports and diagnostic data, providing secure access and easy interpretation for patients and doctors.",
    description:
      "Medical Report Tech digitizes clinical data and diagnostic results into a secure, accessible format. It allows patients to track health trends over time and share reports instantly with healthcare providers. The system often includes AI-driven summaries to help patients understand complex medical terminology. It ensures data privacy while improving the speed and accuracy of medical consultations.",
    price: 280000,
    originalPrice: 300000,
    image: "image/medical-reportt-tech.png",
    createdAt: "2024-02-08T23:00:00Z",
  }

];

const SampleProducts = BASE_PRODUCTS.map((product) => {
  const discountedPrice = Number(product.price) || 0;
  return {
    ...product,
    discountedPrice,
    price: calculateFinalPrice(discountedPrice),
  };
});



export default SampleProducts;

export const PRODUCT_IDS = {
  "Food Delivery":          "FD1928374650ABCD",
  "School Tech":            "ST5647382910XYZW",
  "NGO":                    "NG9988776655QMZN",
  "3D Application Tech":    "3D1122334455AAXB",
  "Transportation Tech":    "TR6677889900LMNOP",
  "Evaluation of Property": "EP12340987MNBVCX",
  "Vehicle & Software Tech": "VS43215678LKJHGF",
  "QR House Access":        "QR98765432POIUYT",
  "Business Access Tech":   "BA45678901ZXCVBN",
  "Tech Enabler":           "TE111222333QQWEE",
  "Ticket Booking Tech":    "TB444555666RTYUI",
  "Business Consultancy":   "BC777888999ASDFG",
  "Cyber Security":         "CS000111222HJKKL",
  "Real Estate":            "RE333444555VBNMM",
  "AIML":                   "AI999000111QWERT",
  "Robotics & Automation":  "RA888777666UIOPL",
  "Smart Watch":            "SW222333444GHJKL",
  "Drone Tech":             "DT555666777MNBVC",
  "General Store":          "GS12121212ABABAB",
  "Groceries":              "GR34343434CDCDCD",
  "E Commerce Tech":        "EC56565656EFEFEF",
  "Social Media":           "SM78787878GHGHGH",
  "Gym Fitness":            "GF90909090IJIJIJ",
  "Sales and HR Tech":      "SH12312312KLKLKL",
  "Family Tech":            "FT45645645MNMNMN",
  "Temple Tech":            "TT78978978OPOPOP",
  "Village Tech":           "VT01010101QRQRQR",
  "Competitive Exams App":  "CE23232323STSTST",
  "Jewelry":                "JW45454545UVUVUV",
  "Media Tech":             "MT67676767WXYWXY",
  "Apartment Tech":         "AP88776655APT44S",
  "Medical Report Tech":    "MR112233MEDREP9Z",
  "Chat Bot":                "CB3030CHAT987XY",
  "Algo Trade":              "AT8989XYTRAD12",
  "Influencer Marketing":     "IM4545MKTGXY22",
  
};

// 🔥 Named export (for helper function)
export const getProductId = (name) => {
  return PRODUCT_IDS[name] || "UNKNOWN_ID";
};
